import { UnitOfMeasure } from '@prisma/client'
import { z } from 'zod'

/**
 * Schema for selected variant state
 */
export const selectedVariantStateSchema = z.object({
  variantId: z.string().nullable(),
  quantity: z.number().min(0, "Quantity must be non-negative"),
  isFullRoll: z.boolean().default(false),
  error: z.string().nullable()
})

export type SelectedVariantStateType = z.infer<typeof selectedVariantStateSchema>

/**
 * Schema for cart variant attributes
 */
export const cartVariantAttributesSchema = z.object({
  variantId: z.string().min(1, "Variant ID is required"),
  color: z.string().optional(),
  dimensions: z.string().optional(),
  unitOfMeasure: z.nativeEnum(UnitOfMeasure).default(UnitOfMeasure.EACH),
  isFullRoll: z.boolean().default(false),
  lengthInUnits: z.number().min(0, "Length must be non-negative"),
  totalUnits: z.number().min(0, "Total units must be non-negative")
})

export type CartVariantAttributesType = z.infer<typeof cartVariantAttributesSchema>

/**
 * Schema for add to cart payload with variant
 */
export const addToCartVariantPayloadSchema = z.object({
  productId: z.string().min(1, "Product ID is required"),
  variantId: z.string().min(1, "Variant ID is required"),
  quantity: z.number().min(1, "Quantity must be positive"),
  isFullRoll: z.boolean().default(false),
  unitOfMeasure: z.nativeEnum(UnitOfMeasure).default(UnitOfMeasure.EACH),
  attributes: cartVariantAttributesSchema
})

/**
 * Schema for add to cart payload without variant (simple product)
 */
export const addToCartSimplePayloadSchema = z.object({
  productId: z.string().min(1, "Product ID is required"),
  quantity: z.number().min(1, "Quantity must be positive"),
  unitOfMeasure: z.nativeEnum(UnitOfMeasure).default(UnitOfMeasure.EACH)
})

/**
 * Combined schema for any add to cart payload
 */
export const addToCartPayloadSchema = z.discriminatedUnion('hasVariant', [
  z.object({
    hasVariant: z.literal(true),
    payload: addToCartVariantPayloadSchema
  }),
  z.object({
    hasVariant: z.literal(false),
    payload: addToCartSimplePayloadSchema
  })
])
